import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { getFloors } from '../../../../../api/Engrain';
import { getAllUnitColors, getUnitMapConfiguration } from '../../../../../api/UnitMap';
import { useFetch } from '../../../../../hooks/useFetch';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import LoadingOverlay, { LoadingDisplay } from '../../../../common/LoadingOverlay';
import ProspectHeader from '../../../../common/ProspectHeader';
import { Floor, MapContext } from '../../../../common/UnitMap/UnitMapTypes';
import UnitMapWrapper from '../../../../common/UnitMap/UnitMapWrapper';

export interface Props extends RouteComponentProps<{ propertySlug: string }> {}

const UnitMapView = (props: Props) => {
    const [selectedFloor, selectFloor] = useState<string>();
    const [selectedStop, selectStop] = useState<number>();
    const [allFloors, setAllFloors] = useState<Floor[]>();
    const [locationEnabled, setLocationEnabled] = useState(false);
    const [map, setMap] = useState<any>();

    const { data: unitMapColorData } = useFetch(() => getAllUnitColors(), [], undefined);

    const {
        data: configuration,
        loading: isLoadingConfig,
        error: mapError
    } = useFetch(() => getUnitMapConfiguration(props.match.params.propertySlug), [], undefined);
    useEffect(() => {
        if (isLoadingConfig || !configuration) {
            return;
        }
        getFloors(configuration.unitMapId).then(floors => {
            setAllFloors(floors);
            if (configuration.stops.length > 0) {
                selectFloor(configuration.stops[0].floor);
            } else {
                selectFloor(floors[0].value);
            }
        });
    }, [isLoadingConfig]);
    return (
        <div className="flex-root prospect-map">
            <ProspectHeader />
            {configuration &&
            configuration.unitMapId &&
            unitMapColorData &&
            !configuration.isDeleted ? (
                <MapContext.Provider
                    value={{
                        configuration,
                        setConfiguration: c => {
                            return;
                        },
                        colors: unitMapColorData,
                        allFloors,
                        selectedFloor,
                        selectFloor,
                        setAllFloors,
                        map,
                        setMap,
                        selectStop,
                        locationEnabled,
                        setLocationEnabled,
                        selectedStopIndex: selectedStop
                    }}
                >
                    {isLoadingConfig ? (
                        <LoadingOverlay show={isLoadingConfig} inBootstrapColumn={false} />
                    ) : !mapError ? (
                        <UnitMapWrapper />
                    ) : (
                        <FormValidationDisplay errorMessage={mapError} />
                    )}
                </MapContext.Provider>
            ) : isLoadingConfig ? (
                <LoadingDisplay />
            ) : (
                <FormValidationDisplay errorMessage="Failed to load map for property" />
            )}
        </div>
    );
};

export default UnitMapView;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/UnitMapView.tsx